import { useAppSelector } from "@store";
import { getCalcFormulaDefs } from "@store/story/selectors";
import { useMemo } from "react";

/**
 * Name → formula map for every "calculation" variable defined in the current
 * story. Feeds the pill-rendering `PillDecorator` (see variable-pill.ts) so a
 * calc pill can show its name + formula tooltip without variable-pill.ts itself
 * needing to know about the calc feature.
 *
 * Formulas are story-local (settings.fs["calc-formulas"]), never org fast-vars
 * — see docs/plans/2026-08-19-story-local-formulas-design.md.
 */
export const useCalcFormulas = (): Record<string, string> => {
  const defs = useAppSelector(getCalcFormulaDefs);

  return useMemo(() => {
    const map: Record<string, string> = {};
    for (const [name, def] of Object.entries(defs)) {
      if (def && typeof def.formula === "string" && def.formula) {
        map[name] = def.formula;
      }
    }
    return map;
  }, [defs]);
};
